import React from 'react';
import { Button } from '@mui/material';

interface FullScreenButtonProps {
  isFullScreen: boolean;
  onClick: () => void;
  variant?: 'text' | 'contained' | 'outlined';
}

const FullScreenButton: React.FC<FullScreenButtonProps> = ({
  isFullScreen,
  onClick,
  variant = 'text',
}) => {
  return (
    <Button
      variant={variant}
      onClick={onClick}
      sx={{
        height: 44,
        width: 44,
        background: 'white',
        borderRadius: '4px',
        border: '1px solid #D4D7DB',
      }}
    >
      {isFullScreen ? (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M0.583984 5.89819C0.583984 5.66807 0.770532 5.48153 1.00065 5.48153H4.89187L3.94765 4.5373L1.36183 1.95149C1.19911 1.78877 1.19911 1.52495 1.36183 1.36223C1.52455 1.19951 1.78837 1.19951 1.95109 1.36223L4.5369 3.94805L5.48348 4.89463L5.48348 0.998698C5.48348 0.768579 5.67003 0.582031 5.90015 0.582031C6.13027 0.582031 6.31681 0.768579 6.31681 0.998698L6.31681 5.89819C6.31681 6.12831 6.13027 6.31486 5.90015 6.31486L1.00065 6.31486C0.770533 6.31486 0.583984 6.12831 0.583984 5.89819ZM9.10729 8.51843H12.8999C13.13 8.51843 13.3165 8.33189 13.3165 8.10177C13.3165 7.87165 13.13 7.6851 12.8999 7.6851H8.00037C7.77025 7.6851 7.5837 7.87165 7.5837 8.10177L7.5837 13.0013C7.5837 13.2314 7.77025 13.4179 8.00037 13.4179C8.23049 13.4179 8.41703 13.2314 8.41703 13.0013L8.41704 9.00669L9.11928 9.70893L12.2051 12.7947C12.3678 12.9575 12.6316 12.9575 12.7943 12.7947C12.9571 12.632 12.9571 12.3682 12.7943 12.2055L9.70853 9.11968L9.10729 8.51843Z"
            fill="black"
          />
        </svg>
      ) : (
        <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M6.34921 0.949219C6.34921 1.22536 6.12535 1.44922 5.84921 1.44922L2.1569 1.44922L4.59615 3.88847L5.88906 5.18138C6.08432 5.37664 6.08432 5.69322 5.88906 5.88849C5.6938 6.08375 5.37721 6.08375 5.18195 5.88849L3.88904 4.59558L1.44971 2.15624L1.44971 5.84871C1.44971 6.12486 1.22585 6.34871 0.949707 6.34871C0.673564 6.34871 0.449707 6.12486 0.449707 5.84871L0.449709 0.949218C0.449709 0.673076 0.673567 0.449219 0.949709 0.449219H5.84921C6.12535 0.449219 6.34921 0.673077 6.34921 0.949219ZM7.76777 7.76719C7.96303 7.57193 8.27961 7.57193 8.47487 7.76719L9.76778 9.0601L12.4503 11.7426L12.4503 8.15072C12.4503 7.87457 12.6741 7.65072 12.9503 7.65072C13.2264 7.65072 13.4503 7.87457 13.4503 8.15072L13.4503 13.0502C13.4503 13.3264 13.2264 13.5502 12.9503 13.5502H8.05078C7.77464 13.5502 7.55078 13.3264 7.55078 13.0502C7.55078 12.7741 7.77464 12.5502 8.05078 12.5502H11.8437L9.06067 9.76721L7.76777 8.4743C7.5725 8.27904 7.5725 7.96246 7.76777 7.76719Z"
            fill="black"
          />
        </svg>
      )}
    </Button>
  );
};

export default FullScreenButton;
